import { NetworkIcon, TokenIcon } from "@unizpay/ui";
import type { ReactNode } from "react";

/** "USDC · Polygon" with the token's logo and the network's badge on it. */
export function AssetLabel({
  token,
  network,
  networkName,
  size = 20,
  stacked = false,
}: {
  token: string;
  /** Slug or chain id, for the logo; the name is what is shown. */
  network: string;
  networkName: string;
  size?: number;
  /** The network on its own line under the token, for narrow places like a side card. */
  stacked?: boolean;
}) {
  if (stacked) {
    return (
      <span className="inline-flex items-center gap-2">
        <TokenIcon symbol={token} network={network} size={size} />
        <span className="min-w-0 leading-tight">
          <span className="block font-medium">{token}</span>
          <span className="block text-xs text-fg-muted">{networkName}</span>
        </span>
      </span>
    );
  }
  return (
    <span className="inline-flex items-center gap-2">
      <TokenIcon symbol={token} network={network} size={size} />
      <span className="min-w-0">
        <span className="font-medium whitespace-nowrap">{token}</span>{" "}
        <span className="whitespace-nowrap text-fg-muted">· {networkName}</span>
      </span>
    </span>
  );
}

/** A network's name with its logo. */
export function NetworkLabel({ network, name, size = 16 }: { network: string; name: string; size?: number }) {
  return (
    <span className="inline-flex items-center gap-1.5 whitespace-nowrap">
      <NetworkIcon network={network} size={size} />
      {name}
    </span>
  );
}

/**
 * A select with the chosen token's or network's logo at its left edge (a native select cannot
 * show images in its options). Give the select `pl-9` so its text clears the logo.
 */
export function WithIcon({ icon, children }: { icon: ReactNode; children: ReactNode }) {
  return (
    <div className="relative">
      {icon && (
        <span className="pointer-events-none absolute top-1/2 left-2.5 flex -translate-y-1/2">{icon}</span>
      )}
      {children}
    </div>
  );
}
